import { Background, style } from '@do/walrus';
import React, { ReactElement } from 'react';
import defaultBg from '../assets/backgrounds/HeroBackground-Option1-01.png';
import { VariantProps } from '../interfaces/variant';
import { Column, Row } from './Common';
import { Splash } from './Splash';

interface Props {
  variant: VariantProps;
}

export const Variant: React.FC<Props> = ({ children, variant }): ReactElement => {
  return variant?.splash ? (
    <Row>
      <Column
        style={{
          background: style.colors.grey.lightest,
        }}
      >
        {children}
      </Column>
      <Splash splash={variant.splash} variantType={variant.type} />
    </Row>
  ) : (
    <>
      <Background url={variant.background?.url || defaultBg} />
      {children}
    </>
  );
};
